module.exports = __webpack_public_path__ + "static/media/logo_ikaat.3b0b5566.png";